<span *ngIf="type === 'primary'" class="primary chips">
    {{labelText}}
</span>
<span *ngIf="type === 'secondary'" class="secondary chips">
    {{labelText}} 
    <img src="../../../assets/svg/cancel-icon.svg" alt="remove" (click)="triggerRemoveEvent()">
</span>